/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RansomwareCapabilitySpec { 
    /**
     * List of AWS regions supported for ransomware recovery deployment
     */
    carbon_black_enabled_aws_regions?: string;
    /**
     * List of Carbon Black regions supported for ransomware recovery deployment
     */
    carbon_black_enabled_pop_ids?: string;
    /**
     * List of all GCP regions supported for ransomware recovery
     */
    carbon_black_enabled_gcp_regions?: string;
    /**
     * Enable/ Disable Check for active IRR (VCDR Deployment) for allowing activating or de-activating RWR
     */
    carbon_black_activation_requires_active_vcdr?: boolean;
    /**
     * Enable/ Disable Check if approval is required for de-activating RWR and automatically de-provisioning its CB PoP
     */
    carbon_black_deactivation_requires_approval?: boolean;
    /**
     * Whether Carbon Black on-premises org and API key management is allowed for this organization.
     */
    carbon_black_org_and_api_key_mgmt_allowed?: boolean;
    /**
     * When enabled, the CB EDR org is deprovisioned only when all associated deployments (cloud + ONPREM shadow) are removed (refcount reaches zero). When disabled, the EDR org is never deprovisioned automatically; it stays in RMS ASSIGNED state regardless of deployment count.
     */
    carbon_black_org_deprovision_by_refcount?: boolean;
    /**
     * The ARN of the OVA to be used by IRR.
     */
    carbon_black_aws_ova_file_path?: string;
    /**
     * The ARN of the OVA to be used by OnPrem IRR.
     */
    carbon_black_onprem_ova_file_path?: string;
    /**
     * The GCP storage URI of the OVA to be used by IRR.
     */
    carbon_black_gcp_ova_file_path?: string;
    /**
     * Enabled crowdstrike EDR regions.
     */
    crowdstrike_enabled_regions?: string;
    /**
     * Enabled VLCR AWS regions for crowdstrike.
     */
    crowdstrike_enabled_aws_regions?: string;
    /**
     * The ARN of the OVA to be used by IRR.
     */
    crowdstrike_aws_ova_file_path?: string;
    /**
     * The ARN of the OVA to be used by OnPrem IRR.
     */
    crowdstrike_onprem_ova_file_path?: string;
    /**
     * Enabled VLCR GCP regions for crowdstrike.
     */
    crowdstrike_enabled_gcp_regions?: string;
    /**
     * The GCP storage URI of the OVA to be used by IRR.
     */
    crowdstrike_gcp_ova_file_path?: string;
    /**
     * Enable/ Disable Check for active IRR for allowing activating or de-activating crowdstrike.
     */
    crowdstrike_activation_requires_active_vcdr?: boolean;
    /**
     * Requires approval for deactivation.
     */
    crowdstrike_deactivation_requires_approval?: boolean;
}

